import { USERS, UPDATE_DELETE_USER, USER_STATUS, ADD_USERS, GET_USER_BY_ID } from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";

export const fetchUsers =
  (role = undefined) =>
    (dispatch, getState, { apiAuth }) => {
      return apiAuth
        .get(USERS)
        .then((result) => result)
        .catch((error) => {
          throw error;
        });
    };

export const createUser =
  (payload) =>
    (dispatch, getState, { apiAuth }) =>
      apiAuth
        .post(ADD_USERS, payload)
        .then((result) => result)
        .catch((error) => {
          throw error;
        });

export const updateUser =
  (uuid, payload) =>
    (dispatch, getState, { apiAuth }) => {
      const url = replaceMultiple(UPDATE_DELETE_USER, { "{{uuid}}": uuid });
      return apiAuth
        .put(url, payload)
        .then((result) => result)
        .catch((error) => {
          throw error;
        });
    };

export const deleteUser =
  (uuid) =>
    (dispatch, getState, { apiAuth }) => {
      const url = replaceMultiple(UPDATE_DELETE_USER, { "{{uuid}}": uuid });
      return apiAuth
        .delete(url)
        .then((result) => result)
        .catch((error) => {
          throw error;
        });
    };

export const updateUserStatus =
  (uuid, payload) =>
    (dispatch, getState, { apiAuth }) => {
      const url = replaceMultiple(USER_STATUS, { "{{uuid}}": uuid });
      return apiAuth
        .put(url, payload)
        .then((result) => result)
        .catch((error) => {
          throw error;
        });
    };

export const getUserByID = (id) => (dispatch, getState, { apiAuth, apiReport }) => {
  const url = replaceMultiple(GET_USER_BY_ID, {
    '{USER_ID}': id
  })
  return apiAuth
    .get(url)
    .then((result) => result)
    .catch((error) => {
      throw error;
    });

}
